// extracted by mini-css-extract-plugin
export default {"navi-icon":"MobileMenuItemListAccordion-bRa7o__navi-icon"};